var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.884 106.631C10.8925 107.872 7.46613 106.448 6.22787 103.461C2.48451 94.4298 0.585938 84.8545 0.585938 75C0.585938 33.8688 33.8825 0.605392 75 0.605392C92.5095 0.605392 110.023 6.72455 124.162 19.1723V5.85938C124.162 2.62299 126.786 0 130.021 0C133.257 0 135.88 2.62299 135.88 5.85938V33.8093C136.057 37.1555 133.349 39.9879 130.021 39.9879H101.744C98.5073 39.9879 95.8843 37.365 95.8843 34.1286C95.8843 30.8922 98.5073 28.2692 101.744 28.2692H116.769C105.651 18.3369 91.1041 12.3241 75 12.3241C40.345 12.3241 12.3047 40.361 12.3047 75C12.3047 83.3061 13.9023 91.3731 17.054 98.9742C18.2922 101.965 16.8743 105.392 13.884 106.631ZM143.772 46.5385C142.533 43.5482 139.105 42.1303 136.116 43.3685C133.126 44.6079 131.708 48.0366 132.946 51.0258C136.098 58.6269 137.695 66.6939 137.695 75C137.695 109.639 109.655 137.676 75 137.676C58.8959 137.676 44.3493 131.663 33.2314 121.731H48.2563C51.4927 121.731 54.1157 119.107 54.1157 115.871C54.1157 112.635 51.4927 110.012 48.2563 110.012H19.9791C16.658 110.012 13.9423 112.818 14.1197 116.191V144.141C14.1197 147.377 16.7427 150 19.9791 150C23.2143 150 25.8385 147.377 25.8385 144.141V130.828C39.9765 143.275 57.4905 149.395 75 149.395C116.117 149.395 149.414 116.131 149.414 75C149.414 65.1455 147.515 55.5702 143.772 46.5385Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 31.5918,
    y1: 118.75,
    x2: 137.679,
    y2: 32.0666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.57b4023d2fb17ac489aabfc393104aff.svg";
export { ForwardRef as ReactComponent };